import Debug from './_debug';
import $ from 'jquery'

let Navigation = {};  


Navigation.initialize = _ => {
  Debug.log('Navigation: initialize');
  Navigation.addLinkOnButtonsWithDataLink();
  Navigation.manageMobileNavigationButtons();
  Navigation.manageSearchFormToggle();
  Navigation.removeBreadcrumbsLinkForParentPage();
  Navigation.openMaladies();
}

Navigation.addLinkOnButtonsWithDataLink = _ => {
  $('button.btn[data-link]').on('click', function() {
    window.location.href = $(this).data('link');
  });
}

Navigation.manageMobileNavigationButtons = _ => {
  $('button[data-mobile-navigation]').on('click', function() {
    Navigation.toggleMenu();
  });
}

Navigation.manageSearchFormToggle = _ => {
  $('button[data-toggle-search]').on('click', function() {
    Navigation.toggleSearchForm();
  });
}

Navigation.toggleMenu = function() {
  $('header.site-header .mobile-navigation-button').toggleClass('active');
  $('header.site-header .mobile-navigation-wrapper').toggleClass('active');        
};  

Navigation.toggleSearchForm = function() {
  $('header .site-search').toggleClass('active');
}; 

Navigation.removeBreadcrumbsLinkForParentPage = _ => {
  let parent = $('.breadcrumbs span span span a');
  parent.parent().prepend('<span>' + parent.html() + '</span>');
  parent.remove();
}

Navigation.openMaladies = function() {
  $('#open-maladies').on('click', _ => {
    $('#panel-maladies').toggleClass('d-none');
    $('#open-maladies').toggleClass('d-none');
  });
}; 



export default Navigation;